import { Link } from "react-router-dom";
import { MapPin, Sparkles } from "lucide-react";
import { SectionHeading } from "@/components/Reveal";

export const nightsAr = (n) => (n === 1 ? "ليلة واحدة" : n === 2 ? "ليلتان" : n <= 10 ? `${n} ليالٍ` : `${n} ليلة`);

export const TripPlanCard = ({ p }) => (
  <Link
    to={`/trip-plans/${p.slug}`}
    data-testid={`trip-plan-card-${p.slug}`}
    className="group relative h-full rounded-3xl border border-slate-200 bg-white overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-[#C80000]/30 hover:shadow-lg block"
  >
    {p.coverImage?.file && (
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={p.coverImage.file} srcSet={p.coverImage.srcset || undefined} sizes="(max-width: 640px) 100vw, 33vw" alt={p.coverImage.caption || p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <span className="absolute top-3 start-3 rounded-full bg-white/90 px-3 py-1 text-[11px] font-bold text-[#C80000] border border-[#C80000]/20">
          {nightsAr(p.nights)} / {p.days} أيام
        </span>
      </div>
    )}
    <div className="p-5">
      <h3 className="text-lg font-bold text-[#1A1A1E] leading-snug">{p.title}</h3>
      {(p.countries?.length || p.cities?.length) > 0 && (
        <p className="mt-1.5 flex items-center gap-1.5 text-xs text-slate-600">
          <MapPin className="h-3.5 w-3.5 text-[#C80000]" />
          {[...(p.countries || []), ...(p.cities || [])].join(" — ")}
        </p>
      )}
      {(p.stays || []).length > 1 && (
        <p className="mt-2 text-[11px] text-slate-500 leading-relaxed">
          {p.stays.map((s) => `${s.city} ${s.nights} ${s.nights === 1 ? "ليلة" : s.nights === 2 ? "ليلتان" : "ليالٍ"}`).join(" ← ")}
        </p>
      )}
      <div className="mt-4 flex items-center justify-between border-t border-slate-200 pt-4">
        <span className="text-sm font-bold text-[#C80000]" data-testid={`trip-plan-price-${p.slug}`}>السعر حسب طلبك</span>
        <span className="text-xs font-bold text-slate-600 group-hover:text-[#C80000] transition-colors">البرنامج المقترح ←</span>
      </div>
    </div>
  </Link>
);

// شبكة مخططات «رحلات حسب طلبك» — عرضية فقط؛ الجلب والفلترة في الصفحة الأم.
// bare=false تضيف عنوان القسم (للاستخدام المستقل)، bare=true للاستخدام داخل تبويب.
const TripPlansSection = ({ plans, bare = false }) => {
  if (!plans || plans.length === 0) return null;

  return (
    <section className={bare ? "" : "mt-20 border-t border-slate-200 pt-14"} id="trip-plans" data-testid="trip-plans-section">
      {!bare && (
        <>
          <SectionHeading caption="صمَّمها على مزاجك" title="رحلات حسب طلبك" />
          <p className="mt-4 max-w-2xl text-sm sm:text-base text-slate-600 leading-relaxed">
            برامج مقترحة بلا سعر ثابت: توزيع الليالي والمدن والأنشطة كلها نقطة بداية — نعدّلها ونصمّم السعر والمشمولات حسب طلبك عبر واتساب.
          </p>
        </>
      )}
      <div className={`${bare ? "mt-6" : "mt-8"} grid gap-5 sm:grid-cols-2 lg:grid-cols-3`} data-testid="trip-plans-grid">
        {plans.map((p) => <TripPlanCard key={p.id} p={p} />)}
      </div>
      <p className="mt-6 flex items-center gap-2 text-[11px] text-slate-500">
        <Sparkles className="h-3.5 w-3.5 text-[#C80000]" />
        كل مخطط قابل للتخصيص بالكامل: المدة، المدن، مستوى الفنادق، والطيران.
      </p>
    </section>
  );
};

export default TripPlansSection;
